import { createSlice } from "@reduxjs/toolkit";

const DenunciationSlice = createSlice({
  name: "denunciations",
  initialState: {
    value: [],
  },
  reducers: {
    UpdateValue(state, { payload }) {
      state.value = payload;
    },
    UpdateRow(state, { payload }) {
      state.value.forEach((item) => {
        if (item.id === payload.id) {
          Object.assign(item, payload);
        }
      });
    },
    DeleteRow(state, { payload }) {
      state.value = state.value.filter((item) => item.id !== payload.id);
    },
    ToggleActive(state, { payload }) {
      state.value.forEach((item) => {
        if (item.comment.id === payload.id) {
          item.active = !payload.active;
        }
      });
    },
  },
});

export const selectAll = (state) => state.denunciations.value;
export const { DeleteRow, UpdateRow, UpdateValue, ToggleActive } =
  DenunciationSlice.actions;
export default DenunciationSlice.reducer;
